import { useStateManager } from "@bcm-dev/bcms-vite";
import { WidgetContainer } from "components/shared";
import React from "react";
import { SVGAsset } from "res";

import "./styles.css";

/**
 * @function ACHBatchConfirmationWidget
 * @param {STRING} reference - Sets the reference number text.
 * @param {STRING} batchName - Sets the batch name text.
 * @param {STRING} creditAmount -Sets the credit amount text.
 * @param {STRING} debitAmount -Sets the debit amount text.
 * @param {STRING} effectiveDate - Sets the effective date text.
 * @return {React.Component}
 * @exported true
 * @description This is ACH Batch Confirmation widget for ActivityACHPage.
 */
export default function ACHBatchConfirmationWidget(props) {
    const { onACHConfirmationClose } = useStateManager();
    const data = props.data ?? {};
    const action = props.action ?? {};
    const achBatch = props.data ?? {}
    const referenceNumber = props.referenceNumber ?? "[referenceNumber]";
    const batchName = props.batchName ?? "[batchName]";
    const creditAmount = props.creditAmount ?? "[creditAmount]";
    const debitAmount = props.debitAmount ?? "[debitAmount]";
    const effectiveDate = props.effectiveDate ?? "[effectiveDate]";

    return (
        <WidgetContainer className="ach-batch-confirmation-widget">
            <div className="flex-container flex-horizontal align-center confirmation-success-container">
                <div className="flex-width flex-container align-center success-message">
                    <SVGAsset id="CircleCheckmarkIcon" className="circle-checkmark-icon" />
                    <span className="success-message-text" data-point={ `ACH_Batch_Confirmation_Batch_Successfully_Initiated_Label` }>Batch Successfully Initiated</span>
                </div>
                <div className="set-width ">
                    <SVGAsset id="CloseX" className="close-x-icon clickable" onClick={onACHConfirmationClose} />
                </div>
            </div>
            <div className="confirmation-content-container">
                <p className="ach-batch-scheduled-text">
                    <span data-point={ `ACH_Batch_Confirmation_Awaiting_Approval_Label` }>Your batch has been scheduled and is awaiting approval(s).</span>
                </p>
                <div className="confirmation-info-container">
                    <div className="flex-container flex-horizontal align-center reference-number">
                        <div className="flex-width info-label text-center">
                            <span>Reference Number:</span>
                        </div>
                        <div className="flex-width info-text">
                            <span>{achBatch.referenceNumber}</span>
                        </div>
                    </div>
                    <div className="flex-container flex-horizontal align-center batch-name">
                        <div className="flex-width info-label text-center">
                            <span>Batch Name:</span>
                        </div>
                        <div className="flex-width info-text">
                            <span>{achBatch.name}</span>
                        </div>
                    </div>
                    <div className="flex-container flex-horizontal align-center credit-amount">
                        <div className="flex-width info-label text-center">
                            <span>Credit Amount:</span>
                        </div>
                        <div className="flex-width info-text">
                            <span>{ achBatch.creditAmount.format() }</span>
                        </div>
                    </div>
                    <div className="flex-container flex-horizontal align-center debit-amount">
                        <div className="flex-width info-label text-center">
                            <span>Debit Amount:</span>
                        </div>
                        <div className="flex-width info-text">
                            <span>{ achBatch.debitAmount.format()}</span>
                        </div>
                    </div>
                    <div className="flex-container flex-horizontal align-center effective-date">
                        <div className="flex-width info-label text-center">
                            <span>Effective Date:</span>
                        </div>
                        <div className="flex-width info-text">
                            <span>{ achBatch.effectiveDate.format("m/d/Y") }</span>
                        </div>
                    </div>
                </div>
            </div>
        </WidgetContainer>
    )
}
